import useSWR from "swr";
import { useSearchParams } from "react-router-dom";

import { useApiAccess } from "./useApiAccess";
import { apiRoutes } from "../../Constants/ApiRoutes";
import { getCategoryBySlug } from "../../Service/CategoryService";

export const useCategoryBySlug = ({ categorySlug }) => {

    const hasAccess = useApiAccess();
    const [searchParams] = useSearchParams();
    const productParam = searchParams.get('product');

    const pathParams = {
        ...(productParam && { product: productParam }),
    };

    return useSWR(
        hasAccess ? `${apiRoutes.categoryBySlug}${categorySlug}` : null,
        () => getCategoryBySlug({ categorySlug }, pathParams)
    );
}